import React, { Component, PropTypes } from 'react';
import idx from 'idx';
import { Link } from 'react-router';
import classnames from 'classnames';
import { LoadingIndicator } from 'common/components/preloader';
import Masonry from 'common/components/masonry';
import Review from 'marketing/containers/review';
import ReviewsAgg from 'marketing/containers/reviews_agg';

export default class Reviews extends Component {
  componentDidMount() {
    const { subcategoryId, fetch, itemCount } = this.props;
    fetch([subcategoryId], { pageSize: itemCount, sortBy: '-publish_comment' });
  }

  componentWillUnmount() {
    this.props.clear();
  }

  getItems() {
   return this.props.items.map(item => {
      return ({
        width: item.client_photo? "66%" : "32%",
        content: <Review item={item} />
      });
   });
  }

  render() {
    const {
      cta, title, background, items, fetching, pageSeoTitle, itemReviewedName
    } = this.props;

    return (
      <div className={classnames("block block-reviews", background)}>
        <div className="block-header">
          <ReviewsAgg
            itemName={itemReviewedName || pageSeoTitle}
            title={<h2 className="text-center">{ title || "Our customers love us!" }</h2>}
          />
        </div>
        <div className="row">
          { fetching?
          <div className="columns small-16">
            <LoadingIndicator fullScreen={false}/>
          </div> :
          <div className="columns small-16">
            { items.length > 0?
            <Masonry items={this.getItems()} gutterWidth="2%"/>:
            <h3>No reviews at the moment.</h3> }
          </div> }
        </div>
        <h3 className="text-center reviews-cta">
          <Link to={idx(cta, _ => _.link) || "/reviews/"}>
            { idx(cta, _ => _.label) || "Check out all customer reviews!" }
          </Link>
        </h3>
      </div>
    );
  }
}

Reviews.propTypes = {
  fetch: PropTypes.func.isRequired,
  clear: PropTypes.func.isRequired,
  items: PropTypes.array.isRequired,
  fetching: PropTypes.bool.isRequired,
  subcategoryId: PropTypes.number.isRequired,
  itemCount: PropTypes.number.isRequired,
  background: PropTypes.string.isRequired,
  title: PropTypes.string,
  pageSeoTitle: PropTypes.string,
  itemReviewedName: PropTypes.string,
  cta: PropTypes.object,
};



// WEBPACK FOOTER //
// ./landing_pages/components/reviews.jsx